export const FIELD_TYPES = {
  STRING: 'string',
  DATE: 'date',
  INT: 'int',
  FLOAT: 'float',
  TEXTAREA: 'textarea',
  DATE_RANGE: 'date_range',
  TEXT: 'text'
};
